import { FaFacebook, FaYoutube, FaInstagram, FaLinkedin } from'react-icons/fa'

export const dropdowns = [
    // { id: 1, name: 'Home', link: 'https://multiplymii-project-5b61ac5e19466df465c.webflow.io/clients', options: []},
    { id: 1, name: 'Pricing', 
        options: [
            {name:'MultiplyMii Pricing', link:'https://www.multiplymii.com/clients/pricing'}, 
            {name:'Salary Guide', link:'https://www.multiplymii.com/salary-guide'}
        ], 
        isButton: false 
    },
    { id: 2, name: 'Company', 
        options: [
            {name:'About Us', link:'https://www.multiplymii.com/clients/about-us'}, 
            {name:'Media', link: 'https://www.multiplymii.com/clients/our-media'},
            {name:'Contact Us', link:'https://www.multiplymii.com/clients/contact-us'}
        ], 
        isButton: false 
    },
    { id: 3, name: 'Success Stories', link: 'https://www.multiplymii.com/success-stories' , options: [] },
    { id: 4, name: 'Resources', 
        options: [
            {name:'Salary Guide', link:'https://hubs.ly/Q01Mv6r60'}, 
            {name:'200+ Free Job Descriptions', link:'https://www.multiplymii.com/job-description'}, 
            {name:'Job Description Builder', link:'https://www.multiplymii.com/build-job-description'}, 
            {name:'Testimonials', link:'https://www.multiplymii.com/success-story/testimonials'}
        ], 
        isButton: false 
    },
    { id: 5, name: 'Blog', link: 'https://www.multiplymii.com/clients/blog', options: [] },
    { id: 6, name: `Let's Connect`, link:'https://meetings.hubspot.com/catcaballero/website-booking-page', options: [], isButton: true },
];

export const footerOptions = [
    { name: 'Explore', 
        options: [
            {name: 'Home', link:'https://www.multiplymii.com/clients'}, 
            {name: 'About Us', link:'https://www.multiplymii.com/clients/about-us'}, 
            {name: 'Our Partners', link:'https://www.multiplymii.com/clients/partners'}, 
            {name: 'Our Media', link:'https://www.multiplymii.com/clients/our-media'}, 
            {name: 'Blog', link:'https://multiplymii-project-5b61ac5e19466df465c.webflow.io/clients/blog'}, 
            {name: 'Contact Us', link:'https://www.multiplymii.com/clients/contact-us'}
        ] 
    },
    { name: 'Quicklinks', 
        options: [
            {name: 'Salary Guide', link:'https://hubs.ly/Q01Mv6r60'}, 
            {name: 'Pricing', link:'https://www.multiplymii.com/clients/pricing'}, 
            {name: 'Job Description', link:'https://www.multiplymii.com/job-description'}, 
            {name: 'Success Stories', link:'https://www.multiplymii.com/success-stories'}, 
            {name:'Our Partners', link:'https://www.multiplymii.com/clients/partners'}
        ] 
    },
    { name: 'Company', 
        options: [
            {name: 'MultiplyMii', link:'https://www.multiplymii.com/'}, 
            {name: 'Escala', link:'https://www.weareescala.com/'}, 
            {name: 'Successful Scales', link:'https://www.successfulscales.com/'}, 
            {name: 'Terms & Conditions', link:'https://www.multiplymii.com/clients/affiliate-program/termsandconditions'}, 
            {name: 'Privacy Policy', link:'https://www.multiplymii.com/privacy-policy'}
        ] 
    },
    { name: 'Social', 
        options: [
            { icon: <FaFacebook />, name: 'Facebook', link: 'https://www.facebook.com/multiplymiicareers' }, 
            { icon: <FaYoutube />, name: 'Youtube', link:'https://www.youtube.com/c/MultiplyMiiCareers' }, 
            { icon: <FaInstagram />, name: 'Instagram', link:'https://www.instagram.com/multiplymiiofficial/' }, 
            { icon: <FaLinkedin />, name: 'LinkedIn', link:'https://www.linkedin.com/company/31020363' }
        ] 
    },
];

export const apiErrorCodes = [
    {
        code: 401,
        overview: 'Invalid Authentication',
        cause: 'Cause: Invalid Authentication',
        solution: 'Solution: Ensure the correct API key and requesting organization are being used.'
    },
    {
        code: 401,
        overview: 'Incorrect API key provided',
        cause: 'Cause: The requesting API key is not correct.',
        solution: 'Solution: Ensure the API key used is correct, clear your browser cache, or generate a new one.'
    },
    {
        code: 401,
        overview: 'You must be a member of an organization to use the API',
        cause: 'Cause: Your account is not part of an organization.',
        solution: 'Solution: Contact us to get added to a new organization or ask your organization manager to invite you to an organization.'
    },
    {
        code: 429,
        overview: 'Rate limit reached for requests',
        cause: 'Cause: You are sending requests too quickly.',
        solution: 'Solution: Pace your requests. Read the Rate limit guide.'
    },
    {
        code: 429,
        overview: 'You exceeded your current quota, please check your plan and billing details',
        cause: 'Cause: You have hit your maximum monthly spend (hard limit) which you can view in the account billing section.',
        solution: 'Solution: Apply for a quota increase.'
    },
    {
        code: 500,
        overview: 'The server had an error while processing your request',
        cause: 'Cause: Issue on our servers.',
        solution: 'Solution: Retry your request after a brief wait and contact us if the issue persists. Check the status page.'
    },
    {
        code: 503,
        overview: 'The engine is currently overloaded, please try again later',
        cause: 'Cause: Our servers are experiencing high traffic.',
        solution: 'Solution: Please retry your requests after a brief wait.'
    }
];

export const rejectedDomains = ["multiplymii.com"]